// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse {
    static getAttributeTypeMap() {
        return ClaimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse.attributeTypeMap;
    }
}
ClaimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse.discriminator = undefined;
ClaimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse.additionalProperties = false;
ClaimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse.js.map